export const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
